import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import { FiChevronDown } from "react-icons/fi";
import "./AdvancedSearch.css";
import { FormRow } from "./Input";
import { DateRangeRow } from "./DateRangerRow";
import { FormValues, toInvoiceSearchPayload } from "./AdvanceType";
import { TextBox } from "./Textbox";
import { Combobox } from "../InvoiceEditor/Components/CommonUI";
import { comboboxOption } from "../InvoiceEditor/constants";
import { GetRbacConfigService } from "../../Services/UserManagementService/UserManagementService";
import { RbacCurrentUser, RbacManagedUser } from "../../Services/UserManagementService/rbac.types";


interface AdvancedSearchProps {
  setIsOpenAdvance: boolean;
  onClose: () => void;
  FetchInvoices: Function;
  onApply?: (searchFields: any) => void;
  formRef?: React.RefObject<{ resetForm: () => void }>;
  activeSearchFields?: Partial<FormValues> | null;
}

const toSubmittedByOption = (
  user: Pick<RbacCurrentUser | RbacManagedUser, "id" | "firstName" | "lastName" | "email">,
): comboboxOption | null => {
  const baseName =
    `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim() || user.email || "";
  if (!baseName) return null;

  const isRemoved = "status" in user && (user as RbacManagedUser).status === 2;
  const optionName = isRemoved ? `${baseName} (removed)` : baseName;

  return {
    // Combobox optionId is typed as number, but user ids are GUIDs.
    optionId: user.id as unknown as number,
    optionName,
  };
};

const AdvancedSearch: React.FC<AdvancedSearchProps> = ({
  setIsOpenAdvance,
  onClose,
  FetchInvoices,
  onApply,
   formRef, 
  activeSearchFields,
}) => {
  const modalRef = useRef<HTMLFormElement>(null);
  const [submittedByOptions, setSubmittedByOptions] = useState<comboboxOption[]>([]);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
      onClose();
    }
  };
  useEffect(() => {
    if (setIsOpenAdvance) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [setIsOpenAdvance]);

  useEffect(() => {
    if (!setIsOpenAdvance) return;

    let cancelled = false;

    const loadSubmittedByUsers = async () => {
      const { users = [], currentUser } = (await GetRbacConfigService()) ?? {};
      if (cancelled) return;

      const userList: Array<RbacCurrentUser | RbacManagedUser> = [...users];
      if (currentUser?.id && !userList.some((user) => user.id === currentUser.id)) {
        userList.unshift(currentUser);
      }

      const options = userList
        .map(toSubmittedByOption)
        .filter((option): option is comboboxOption => option !== null)
        .sort((a, b) => a.optionName.localeCompare(b.optionName));

      setSubmittedByOptions(options);
    };

    loadSubmittedByUsers();

    return () => {
      cancelled = true;
    };
  }, [setIsOpenAdvance]);

  const formik = useFormik<FormValues>({
    enableReinitialize: true,
    initialValues: {
      ...activeSearchFields,
      searchTerm: "",
      supplier: "",
      amountFrom: "",
      amountTo: "",
      dateFrom: "",
      dateTo: "",
      dueDateFrom: "",
      dueDateTo: "",
      uploadDateFrom: "",
      uploadDateTo: "",
      exportDateFrom: "",
      exportDateTo: "",
      docRef: "",
      itemId: "",
      type: "",
      currencyCode: "",
      payment: "",
      user: "",
      submittedBy: "",
      submittedByLabel: activeSearchFields?.submittedByLabel || "None",
      submissionMethod: "",
      category: "",
      expenseClaim: "",
      name: ""
    },
   onSubmit: (values) => {
  const filledValues = Object.fromEntries(
    Object.entries(values).filter(([key, v]) => key !== "submittedByLabel" && v !== "")
  );

  if (filledValues.uploadDateFrom) {
    filledValues.uploadDateFrom = filledValues.uploadDateFrom;  
  }
  if (filledValues.uploadDateTo) {
    filledValues.uploadDateTo = filledValues.uploadDateTo;
  }

  const activeSearch = Object.keys(filledValues).length
    ? {
        ...filledValues,
        ...(values.submittedBy && values.submittedByLabel
          ? { submittedByLabel: values.submittedByLabel }
          : {}),
      }
    : null;

  FetchInvoices(false, false, null,null, toInvoiceSearchPayload(activeSearch));

  console.log("Search:", toInvoiceSearchPayload(activeSearch));
   onApply?.(activeSearch);
  onClose();
}
  });
  useEffect(() => {
       if (formRef) {
         (formRef as any).current = { resetForm: formik.resetForm };
       }
     }, [formRef, formik.resetForm]);

  if (!setIsOpenAdvance) return null;

  return (
    <div className="advanced-search-overlay" onClick={handleOverlayClick}>
      <form ref={modalRef} className="advanced-search-modal" onSubmit={formik.handleSubmit}>
        <div className="headertext">
          <h4>ADVANCED SEARCH</h4>
        </div>
        <div className="body">
          {/* <FormRow label="Search term" labelWidth="100%">
            <input type="text" {...formik.getFieldProps("search Term")} style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }} />
          </FormRow> */}
           <TextBox
            label="search Term"
            name="searchTerm"
            value={formik.getFieldProps("searchTerm").value}
            onChange={formik.handleChange}
            placeholder="Enter search Term"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          />

          {/* <FormRow label="Supplier" labelWidth="100%">
            <div className="select-wrapper">
              <select {...formik.getFieldProps("supplier")} style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                outline: "none",
                fontSize: "var(--font-size-base)",
                cursor: "pointer"
              }}>
                <option value="">Select supplier</option>
                <option value="supplierA">Supplier A</option>
              </select>
              <FiChevronDown className="icon" />
            </div>
          </FormRow> */}
          <TextBox
            label="supplier"
            name="supplier"
            value={formik.getFieldProps("supplier").value}
            onChange={formik.handleChange}
            placeholder="Enter supplier name"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          />


          <FormRow label="Amount">
  <div className="date-container" style={{ display: "flex", gap: "8px" }}>
    <TextBox
      label=""
      name="amountFrom"
      type="number"
      value={formik.getFieldProps("amountFrom").value}
      onChange={(e) =>
        formik.setFieldValue(
          "amountFrom",
          e.target.value === "" ? "" : parseFloat(e.target.value)
        )
      }
      placeholder="0.00"
      inputStyle={{
        width: "100%",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        outline: "none",
        fontSize: "var(--font-size-base)",
      }}
    />
    <span className="separator" style={{ alignSelf: "center" }}>
      to
    </span>
    <TextBox
     label=""
      name="amountTo"
      type="number"
      value={formik.getFieldProps("amountTo").value}
      onChange={(e) =>
        formik.setFieldValue(
          "amountTo",
          e.target.value === "" ? "" : parseFloat(e.target.value)
        )
      }
      placeholder="0.00"
      inputStyle={{
        width: "100%",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "4px",
        outline: "none",
        fontSize: "var(--font-size-base)",
      }}
    />
  </div>
</FormRow>

          <DateRangeRow label="Date" namePrefix="date" formik={formik} />
          <DateRangeRow label="Due date" namePrefix="dueDate" formik={formik} />
          <DateRangeRow label="Upload date" namePrefix="uploadDate" formik={formik} />
          {/* <DateRangeRow label="Export date" namePrefix="exportDate" formik={formik} /> */}

          {/* <FormRow label="Document reference">
            <input type="text" {...formik.getFieldProps("docRef")} style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }} />
          </FormRow> */}
           <TextBox
            label="Document reference"
            name="docRef"
            value={formik.getFieldProps("docRef").value}
            onChange={formik.handleChange}
            placeholder="Enter document reference"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          />
          

          {/* <FormRow label="Item ID">
            <input type="text" {...formik.getFieldProps("itemId")} style={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }} />
          </FormRow> */}

           <TextBox
            label="Item ID"
            name="itemId"
            value={formik.getFieldProps("itemId").value}
            onChange={formik.handleChange}
            placeholder="Enter item ID"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          />

          {/* <FormRow label="Type">
            <div className="select-wrapper">
              <select {...formik.getFieldProps("type")} style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                outline: "none",
                fontSize: "var(--font-size-base)",
                cursor: "pointer"
              }}>
                <option value=""></option>
                <option value="invoice">Invoice</option>
              </select>
              <FiChevronDown className="icon" />
            </div>
          </FormRow> */}
          <TextBox
            label="Type"
            name="type"
            value={formik.getFieldProps("type").value}
            onChange={formik.handleChange}
            placeholder="Enter type"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          />

          {/* New Fields from Screenshot */}
          {/* <FormRow label="Currency code">
            <div className="select-wrapper">
              <select {...formik.getFieldProps("currencyCode")} style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                outline: "none",
                fontSize: "var(--font-size-base)",
                cursor: "pointer"
              }}>
                <option value=""></option>
                <option value="USD">USD</option>
              </select>
              <FiChevronDown className="icon" />
            </div>
          </FormRow> */}

          <TextBox
            label="Currency Code"
            name="currencyCode"
            value={formik.getFieldProps("currencyCode").value}
            onChange={formik.handleChange}
            placeholder="Enter currency code"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          />
          

          {/* <FormRow label="Payment">
            <div className="select-wrapper">
              <select {...formik.getFieldProps("payment")} style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                outline: "none",
                fontSize: "var(--font-size-base)",
                cursor: "pointer"
              }}>
                <option value=""></option>
                <option value="paid">Paid</option>
              </select>
              <FiChevronDown className="icon" />
            </div>
          </FormRow> */}
           <TextBox
            label="Payment"
            name="payment"
            value={formik.getFieldProps("payment").value}
            onChange={formik.handleChange}
            placeholder="Enter payment status"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          />

          {/* <FormRow label="User">
            <div className="select-wrapper">
              <select {...formik.getFieldProps("user")} style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                outline: "none",
                fontSize: "var(--font-size-base)",
                cursor: "pointer"
              }}>
                <option value=""></option>
              </select>
              <FiChevronDown className="icon" />
            </div>
          </FormRow> */}
             {/* <TextBox
            label="User"
            name="user"
            value={formik.getFieldProps("user").value}
            onChange={formik.handleChange}
            placeholder="Enter user"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          /> */}

          <FormRow label="Submitted By">
            <div className="advanced-search-combobox">
              <Combobox
                name="submittedBy"
                label=""
                value={formik.values.submittedByLabel ?? ""}
                options={[{ optionId: null, optionName: "None" }, ...submittedByOptions]}
                onChange={(value, option) => {
                  if (option === null && value === "") {
                    formik.setFieldValue("submittedBy", "");
                    formik.setFieldValue("submittedByLabel", "None");
                    return;
                  }

                  const isCleared = value === "None" || option?.optionName === "None" || option?.optionId == null;
                  formik.setFieldValue("submittedBy", isCleared ? "" : String(option.optionId));
                  formik.setFieldValue("submittedByLabel", isCleared ? "None" : value);
                }}
                renderOption={(option) => {
                  const isRemoved = option.optionName.endsWith(" (removed)");
                  if (!isRemoved) return <span>{option.optionName}</span>;
                  const baseName = option.optionName.replace(" (removed)", "");
                  return (
                    <span className="submittedby-option">
                      <span>{baseName}</span>
                      <span className="submittedby-removed-badge">removed user</span>
                    </span>
                  );
                }}
              />
            </div>
          </FormRow>

          {/* <FormRow label="Submission method">
            <div className="select-wrapper">
              <select {...formik.getFieldProps("submissionMethod")} style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                outline: "none",
                fontSize: "var(--font-size-base)",
                cursor: "pointer"
              }}>
                <option value=""></option>
              </select>
              <FiChevronDown className="icon" />
            </div>
          </FormRow> */}
          {/* <TextBox
            label="submissionMethod"
            name="submissionMethod"
            value={formik.getFieldProps("submissionMethod").value}
            onChange={formik.handleChange}
            placeholder="Enter submissionMethod"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          /> */}

          {/* <FormRow label="Category" labelWidth="30%">
            <div className="select-wrapper">
              <select {...formik.getFieldProps("category")} style={{
                width: "100%",
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                outline: "none",
                fontSize: "var(--font-size-base)",
                cursor: "pointer"
              }}>
                <option value=""></option>
              </select>
              <FiChevronDown className="icon" />
            </div>
          </FormRow> */}
           <TextBox
            label="Category"
            name="category"
            value={formik.getFieldProps("category").value}
            onChange={formik.handleChange}
            placeholder="Enter category"
            inputStyle={{
              width: "100%",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              outline: "none",
              fontSize: "var(--font-size-base)",
              cursor: "pointer"
            }}
          />

          <div>
            <FormRow label="Expense Claim">
              <div className="select-wrapper disabled-wrapper">
                <select
                  {...formik.getFieldProps("expenseClaim")}
                  style={{
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    outline: "none",
                    fontSize: "var(--font-size-base)",
                    cursor: "pointer"
                  }}
                  disabled
                >
                  <option value=""></option>
                </select>
                <FiChevronDown className="icon" />
              </div>
            </FormRow>
           <p className="expense-claim-helper">
           The expense claim filter is now under the icon next to the search bar.
           </p>
           </div>
        </div>

        <div className="footer">
          <button type="button" onClick={() => {formik.resetForm(); onApply?.(null)}} className="btn-reset">
            Reset
          </button>
          <button type="submit" className="btn-apply">
            Apply
          </button>
        </div>
      </form>
    </div>
  );
};

// Sub-components
// const FormRow: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
//   <div className="row">
//     <label className="label">{label}</label>
//     <div className="field-content">{children}</div>
//   </div>
// );


export default AdvancedSearch;